var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78906 40.1978L21.4668 4.57275L41.1446 40.1978H1.78906ZM7.96073 36.4478H34.9729L21.4668 12.0728L7.96073 36.4478ZM21.4668 34.5728C21.9737 34.5728 22.3986 34.3931 22.7414 34.0337C23.0843 33.6743 23.2557 33.229 23.2557 32.6978C23.2557 32.1665 23.0843 31.7212 22.7414 31.3618C22.3986 31.0024 21.9737 30.8228 21.4668 30.8228C20.96 30.8228 20.5351 31.0024 20.1923 31.3618C19.8494 31.7212 19.678 32.1665 19.678 32.6978C19.678 33.229 19.8494 33.6743 20.1923 34.0337C20.5351 34.3931 20.96 34.5728 21.4668 34.5728ZM19.678 28.9478H23.2557V19.5728H19.678V28.9478Z",
    fill: "#575556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.39c26b040af2c9bca59b13370dbc516d.svg";
export { ForwardRef as ReactComponent };